import React, { ReactNode } from 'react';
import styled from 'styled-components';

import { Pane } from '../Pane/Pane';

const ModalTitleContainer = styled.div`
  padding: 8px 16px;
`;

interface MobileDialogProps {
  visible: boolean;
  onClose?(): void;
  title?: ReactNode;
  footer?: ReactNode;
  afterClose?: () => void;
  closable?: boolean;
}

export const BaseMobileModal: React.FC<MobileDialogProps> = ({
  children,
  visible,
  onClose,
  title,
  footer,
  afterClose,
  closable,
}) => {
  return (
    <Pane
      buttonDestroy={closable !== false}
      events={{
        onBackdropTap: () => {
          onClose?.();
          afterClose?.();
        },
        onDidDismiss: () => {
          onClose?.();
          afterClose?.();
        },
      }}
      visible={visible}
    >
      {title && <ModalTitleContainer>{title}</ModalTitleContainer>}
      {children}
      {footer}
    </Pane>
  );
};
